import { Action } from '@ngrx/store';
import { IShipmentLocationResponse } from '@cemex-core/cmx-api/models/shipment-location/shipment-location-response';
import {
  IAddressResponse,
  IRequestedAddressResponse,
} from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { IPointOfDeliverySalesArea } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-area';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { Jobsite } from '../../models/order-management/jobsite.model';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';

export const POD_LOAD_INITIAL_STATE = '[POD Bulk CEM UL] Load initial state';
export const POD_LOAD = '[POD Bulk CEM UL] Load';
export const POD_LOAD_COMPLETE = '[POD Bulk CEM UL] Load Complete';
export const POD_LOAD_FAIL = '[POD Bulk CEM UL] Load Fail';
export const POD_REMOVE_SELECTED_POD = '[POD Bulk CEM UL] Remove Selected';
export const POD_SET = '[POD Bulk CEM UL] Set';
export const POD_LOAD_ADDRESS = '[POD Bulk CEM UL] Load address';
export const POD_LOAD_ADDRESS_SUCCESS = '[POD Bulk CEM UL] Load address success';
export const POD_LOAD_ADDRESS_FAIL = '[POD Bulk CEM UL] Load address fail';
export const POD_LOAD_SALES_AREA = '[POD Bulk CEM UL] Load sales area';
export const POD_LOAD_SALES_AREA_SUCCESS = '[POD Bulk CEM UL] Load sales area success';
export const POD_LOAD_SALES_AREA_FAIL = '[POD Bulk CEM UL] Load sales area fail';
export const POD_SET_AVAILABILITY = '[POD Bulk CEM UL] set availability';
export const POD_SET_REQUIRED = '[POD Bulk CEM UL] set required';

export const POD_TOGGLE_SHOWING_POD_REQUESTS = '[POD Bulk CEM UL] toggle showing pod requests';

export class PODLoadInitialStateAction implements Action {
  readonly type = POD_LOAD_INITIAL_STATE;

  constructor(public payload?: ILocationConfigUnit) {}
}

export class PODLoadAction implements Action {
  readonly type = POD_LOAD;

  constructor(public payload: Jobsite) {}
}

export class PODSetRequiredAction implements Action {
  readonly type = POD_SET_REQUIRED;

  constructor(public payload: boolean) {}
}

export class PODLoadCompleteAction implements Action {
  readonly type = POD_LOAD_COMPLETE;

  constructor(public payload: IShipmentLocationResponse) {}
}

export class PODLoadFailAction implements Action {
  readonly type = POD_LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class PODRemoveSelectedAction implements Action {
  readonly type = POD_REMOVE_SELECTED_POD;

  constructor(public payload: null) {}
}

export class PODSetAction implements Action {
  readonly type = POD_SET;

  constructor(public payload: IShipmentLocation) {}
}

export class LoadPODAddress {
  readonly type = POD_LOAD_ADDRESS;

  constructor(public payload: Jobsite) {}
}

export class LoadPODAddressComplete {
  readonly type = POD_LOAD_ADDRESS_SUCCESS;

  constructor(public payload: IAddressResponse | IRequestedAddressResponse) {}
}

export class LoadPODAddressFail {
  readonly type = POD_LOAD_ADDRESS_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class LoadPODSalesArea {
  readonly type = POD_LOAD_SALES_AREA;

  constructor(public payload: Jobsite) {}
}

export class LoadPODSalesAreaComplete {
  readonly type = POD_LOAD_SALES_AREA_SUCCESS;

  constructor(public payload: IPointOfDeliverySalesArea[]) {}
}

export class LoadPODSalesAreaFail {
  readonly type = POD_LOAD_SALES_AREA_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class PODSetAvailabilityAction {
  readonly type = POD_SET_AVAILABILITY;

  constructor(public payload: boolean) {}
}

export class PODToggleShowingRequestsAction {
  readonly type = POD_TOGGLE_SHOWING_POD_REQUESTS;

  constructor(public payload: boolean) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type PODActions =
  | PODLoadInitialStateAction
  | PODLoadAction
  | PODLoadCompleteAction
  | PODLoadFailAction
  | PODRemoveSelectedAction
  | PODSetAction
  | LoadPODAddress
  | LoadPODAddressComplete
  | LoadPODAddressFail
  | LoadPODSalesArea
  | LoadPODSalesAreaComplete
  | LoadPODSalesAreaFail
  | PODSetAvailabilityAction
  | PODToggleShowingRequestsAction
  | PODSetRequiredAction;
